/*** IMPORTS FROM imports-loader ***/
var jquery = require("jquery");

require('./angular');
module.exports = angular;




/*****************
 ** WEBPACK FOOTER
 ** ./~/angular/index.js
 ** module id = 0
 ** module chunks = 9
 **/